import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const CropListingList = lazy(() => import('../../pages/marketplace/crop_listing/CropListingList'));
const MarketplaceView = lazy(() => import('../../pages/marketplace/marketplace/MarketplaceView'));

export const MarketplaceImport = {
    RoutesMap,
    CropListingList,
    MarketplaceView,
}